import state from '@/vuex/caixa-postal/state.js'
import getters from '@/vuex/caixa-postal/getters.js'
import mutations from '@/vuex/caixa-postal/mutations.js'
import actions from '@/vuex/caixa-postal/actions.js'

const module = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

export default module
